import { Utils, ArrayUtils } from "@/plugins/utils"
import Enums from "@/plugins/Enums"

export default {
	namespaced: true,
	state: {
		lstCv3: [],
		cv3: {
			cv3opercom: "",
			cv3nome: "",
			cv3desc: "",
			cv3grupo: "",
			cv3cupom: false,
			cv3totaliz: "",
			cv3contad: "",
			cv3contac: "",
			cv3observ: "",
			cv3cfop: "",
			cv3cst: "",
			cv3docfis: "",
			cv3titulo: "",
			cv3entsai: 0,
			cv3entsaidesc: "",
			cv3emissao: false,
			cv3tipovol: 0,
			cv3frete: 0,
			cv3conpgto: "",
			cv3lista: "",
			cv3cliente: "",
			cv3editar: false,
			cv3marcvol: "",
			cv3itemfab: 0,
			cv3consig: false,
			cv3baseicm: 0,
			cv3aliqicm: 0,
			cv3baseise: 0,
			cv3baseout: 0,
			cv3basesub: 0,
			cv3aliqsub: 0,
			cv3credicm: false,
			cv3tamanho: false,
			cv3ean: false,
			cv3cnpj: false,
			cv3cic: false,
			cv3credsim: 0,
			cv3cstipi: "",
			cv3cstpis: "",
			cv3basepis: 0,
			cv3aliqpis: 0,
			cv3cstcof: "",
			cv3basecof: 0,
			cv3aliqcof: 0,
			cv3baseiss: 0,
			cv3aliqiss: 0,
			cv3codiss: "",
			cv3naocont: false,
			cv3origem: "",
			cv3enqipi: "",
			cv3aliqipi: 0,
			cv3peso: false,
			cv3ajuste: false,
			cv3credpis: false,
			cv3credcof: false,
			cv3inativa: false,
			cv3comple: false,
			cv3inativadesc: "",
			cv3tottri1: false,
			cv3peca: false,
			cv3pdif: 0,
			cv3alqdest: 0,
			cv3pfcp: 0,
			cv3partil: 0,
			cv3consfin: false,
			cv3pisserv: 0,
			cv3cofserv: 0,
			cv3gs1int: false,
			cv3cbenef: "",
			cv3indpres: "",
			cv1nome: "",
			cv1modelo: "",
			lstcv4: [],
			cv3debt: false,
			cv3credit: false,
			cv3doacao: false,
			cv3tpdebt: "",
			cv3tpcred: "",
			cv3predgov: 0,
			cv3opegov: Enums.GovernmentOperationTypeEnum.NONE,
			cv3cstiva: "",
			cv3tribiva: "",
			cv3aliibsu: 0,
			cv3difibsu: 0,
			cv3aliibsm: 0,
			cv3difibsm: 0,
			fidredibs: 0,
			cv3alicbs: 0,
			cv3difcbs: 0,
			fidredcbs: 0,
			cv3refcli: false,
			cv3gercom: false,
		},
		insert: false,
		update: false,
		loading: false,
		itemsPerPage: 20,
		search: "",
		hasNext: false,
		lastUpdatedRegister: null,
		lstDisabledFields: [],
		lstDisabledTabs: [],
		tabsFieldsToDisableAndCleanCaseCv3entsai3Or4: {
			ipi: ["cv3enqipi", "cv3aliqipi", "cv3cstipi"],
			pis: ["cv3pisserv", "cv3cstpis", "cv3basepis", "cv3aliqpis", "cv3credpis"],
			cofins: ["cv3cofserv", "cv3cstcof", "cv3basecof", "cv3aliqcof", "cv3credcof"],
			issqn: ["cv3baseiss", "cv3aliqiss", "cv3codiss"],
			irr: ["cv3baseirr", "cv3aliqirr"],
			icms: [
				"cv3cst",
				"cv3baseicm",
				"cv3baseise",
				"cv3baseout",
				"cv3aliqicm",
				"cv3basesub",
				"cv3totaliz",
				"cv3peso",
				"cv3pdif",
				"cv3credsim",
				"cv3cbenef",
				"cv3alqdest",
				"cv3pfcp",
				"cv3partil",
			],
		},
	},
	getters: {
		getInsert: state => state.insert,
		getUpdate: state => state.update,
		getLoading: state => state.loading,
		getCv3: state => {
			state.cv3.vd4limdesc = parseFloat(state.cv3.vd4limdesc)
			return state.cv3
		},
		getLstCv3: state => state.lstCv3,
		getLastUpdatedRegister: state => state.lastUpdatedRegister,
		getItemsPerPage: state => state.itemsPerPage,
		getSearch: state => state.search,
		getHasNext: state => state.hasNext,
		getCv3docfis: state => state.cv3.cv3docfis,
		getCv3opercom: state => state.cv3?.cv3opercom ?? "",
		getLstCv4: state => state.cv3.lstCv4,
		getLstDisabledFields: state => state.lstDisabledFields,
		getLstDisabledTabs: state => state.lstDisabledTabs,
		getCv3cfop: state => state.cv3.cv3cfop,
		getCv3entsai: state => state.cv3.cv3entsai,
		getFieldsToDisableAndCleanCaseCv3entsai3Or4: _ => [
			"cv3cfop",
			"cv3baseicm",
			"cv3baseise",
			"cv3baseout",
			"cv3basesub",
			"cv3aliqicm",
			"cv3aliqsub",
			"cv3cst",
			"cv3pdif",
			"cv3credsim",
			"cv3origem",
			"cv3consig",
			"cv3naocont",
			"cv3credicm",
			"cv3cupom",
			"cv3ajuste",
			"cv3baseicm",
			"cv3comple",
			"cv3consfin",
			"cv3marcvol",
			"cv3tipovol",
			"cv3frete",
			"cv3tamanho",
			"cv3ean",
			"cv3peca",
			"cv3gs1int",
			"cv3cbenef",
			"cv3alqdest",
			"cv3pfcp",
			"cv3partil",
			"cv3debt",
			"cv3credit",
			"cv3doacao",
			"cv3tpdebt",
			'cv3tpcred',
			'cv3predgov',
			'cv3opegov',
			'cv3cstiva',
			'cv3tribiva',
			'cv3refcli',
		],
		getTabsToDisableAndCleanCaseCv3entsai3Or4: _ => ["ipi", "pis", "cofins", "issqn", "irr", "icms"],
		getTabsFieldsToDisableAndCleanCaseCv3entsai3Or4: state => state.tabsFieldsToDisableAndCleanCaseCv3entsai3Or4,
		getTabsToEnableCaseCv1modelo55Or65: _ => ["icms", "ipi", "pis", "cofins"],
		getCv1modelo: state => state.cv3.cv1modelo,
	},
	mutations: {
		setCv3: (state, cv3) => (state.cv3 = cv3),
		setInsert: (state, insert) => (state.insert = insert),
		setUpdate: (state, update) => (state.update = update),
		setSearch: (state, search) => (state.search = search),
		setLoading: (state, loading) => (state.loading = loading),
		setLstCv3: (state, lstCv3) => (state.lstCv3 = lstCv3),
		setLstCv4: (state, lstCv4) => (state.cv3.lstCv4 = lstCv4),
		setLstDisabledFields: (state, lstDisabledFields) => (state.lstDisabledFields = lstDisabledFields),
		setLstDisabledTabs: (state, lstDisabledTabs) => (state.lstDisabledTabs = lstDisabledTabs),
		set(state, cv3) {
			state.cv3 = cv3
			if (cv3) state.update = true
		},
		initForm(state) {
			state.insert = false
			state.update = false
			state.cv3 = {
				cv3opercom: "",
				cv3nome: "",
				cv3desc: "",
				cv3grupo: "",
				cv3cupom: false,
				cv3totaliz: "",
				cv3contad: "",
				cv3contac: "",
				cv3observ: "",
				cv3cfop: "",
				cv3cst: "",
				cv3docfis: "",
				cv3titulo: "",
				cv3entsai: 0,
				cv3entsaidesc: "",
				cv3emissao: false,
				cv3tipovol: 0,
				cv3frete: 0,
				cv3conpgto: "",
				cv3lista: "",
				cv3cliente: "",
				cv3editar: false,
				cv3marcvol: "",
				cv3itemfab: 0,
				cv3consig: false,
				cv3baseicm: 0,
				cv3aliqicm: 0,
				cv3baseise: 0,
				cv3baseout: 0,
				cv3basesub: 0,
				cv3aliqsub: 0,
				cv3credicm: false,
				cv3tamanho: false,
				cv3ean: false,
				cv3cnpj: false,
				cv3cic: false,
				cv3credsim: 0,
				cv3cstipi: "",
				cv3cstpis: "",
				cv3basepis: 0,
				cv3aliqpis: 0,
				cv3cstcof: "",
				cv3basecof: 0,
				cv3aliqcof: 0,
				cv3baseiss: 0,
				cv3aliqiss: 0,
				cv3codiss: "",
				cv3naocont: false,
				cv3origem: "",
				cv3enqipi: "",
				cv3aliqipi: 0,
				cv3peso: false,
				cv3ajuste: false,
				cv3credpis: false,
				cv3credcof: false,
				cv3inativa: false,
				cv3inativadesc: "",
				cv3tottri1: false,
				cv3peca: false,
				cv3pdif: 0,
				cv3alqdest: 0,
				cv3pfcp: 0,
				cv3partil: 0,
				cv3consfin: false,
				cv3comple: false,
				cv3pisserv: 0,
				cv3cofserv: 0,
				cv3gs1int: false,
				cv3cbenef: "",
				cv3indpres: "",
				cv1nome: "",
				cv1modelo: "",
				lstcv4: [],
				cv3debt: false,
				cv3credit: false,
				cv3doacao: false,
				cv3tpdebt: "",
				cv3tpcred: "",
				cv3predgov: 0,
				cv3opegov: Enums.GovernmentOperationTypeEnum.NONE,
				cv3cstiva: "",
				cv3tribiva: "",
				cv3aliibsu: 0,
				cv3difibsu: 0,
				cv3aliibsm: 0,
				cv3difibsm: 0,
				fidredibs: 0,
				cv3alicbs: 0,
				cv3difcbs: 0,
				fidredcbs: 0,
				cv3refcli: false,
				cv3gercom: false,
			}
		},
		setParamsDataTable(state, payload) {
			state.lstCv3 = payload.items
			state.itemsPerPage = payload.limit
			state.hasNext = payload.hasNext
		},
	},
	actions: {
		setCv3: ({ commit }, cv3) => commit("setCv3", cv3),
		setInsert: ({ commit }, insert) => {
			commit("setInsert", insert)
			commit("setUpdate", !insert)
		},
		setUpdate: ({ commit }, update) => {
			commit("setUpdate", update)
			commit("setInsert", !update)
		},
		setSearch: ({ commit }, search) => commit("setSearch", search),
		setLoading: ({ commit }, loading) => commit("setLoading", loading),
		setLstCv3: ({ commit }, lstCv3) => commit("setLstCv3", lstCv3),
		setLstCv4: ({ commit }, lstCv4) => commit("setLstCv4", lstCv4),
		setLstDisabledFields: async ({ commit, rootGetters, dispatch, getters }, lstDisabledFields) => {
			await dispatch("lx0/find", null, { root: true })
			var lx0crt = rootGetters["lx0/getLx0crt"]
			const fieldsToDisableCaseLx0crt1Or2 = ["cv3basesub", "cv3aliqsub", "cv3pdif", "cv3cbenef"]
			commit("setLstDisabledFields", lstDisabledFields)
			if (lx0crt != Enums.TributaryRegimeCodeType.RegimeNormal) {
				commit(
					"setLstDisabledFields",
					ArrayUtils.AddItemsToArray(getters.getLstDisabledFields, fieldsToDisableCaseLx0crt1Or2),
				)
			} else {
				commit(
					"setLstDisabledFields",
					ArrayUtils.RemoveItemsFromArray(getters.getLstDisabledFields, fieldsToDisableCaseLx0crt1Or2),
				)
			}
		},
		setLstDisabledTabs: ({ commit, getters }, lstDisabledTabs) => {
			commit("setLstDisabledTabs", lstDisabledTabs)
		},
		initForm: async ({ commit, dispatch }) => {
			commit("initForm")
			await dispatch("setLstDisabledFields", [])
		},
		async get({ dispatch }, cv3opercom) {
			return await this._vm.$axios
				.get(`/Oryx/BusinessOperation/Find/${cv3opercom}`)
				.then(response => {
					return Utils.ValidateAxiosResponse(response.data)
				})
				.catch(error => {
					dispatch(
						"parameters/openDialog",
						{
							titleText: "Erro",
							titleColor: "red",
							text: error.message,
						},
						{ root: true },
					)
					return null
				})
		},
		async find({ commit, dispatch }, { cv3opercom }) {
			commit("setLoading", true)
			commit("initForm")
			await dispatch("get", cv3opercom)
				.then(cv3 => {
					commit("set", cv3)
				})
				.catch(error => {
					dispatch(
						"parameters/openDialog",
						{
							titleText: "Erro",
							titleColor: "red",
							text: error.message,
						},
						{ root: true },
					)
				})
			commit("setLoading", false)
		},
		async save({ dispatch, getters }) {
			dispatch("cleanCv3")
			if (getters.getUpdate) {
				return await dispatch("update")
			}
			return await dispatch("insert")
		},
		async insert({ commit, dispatch, getters }) {
			dispatch(
				"parameters/openGlobalLoading",
				{ showLoadingGlobal: true, text: "Salvando", indeterminate: true },
				{ root: true },
			)
			let payload = await this._vm.$axios
				.post("/Oryx/BusinessOperation/Insert", getters.getCv3)
				.then(response => {
					Utils.ValidateAxiosResponse(response.data)
					commit("initForm")
					return true
				})
				.catch(error => {
					dispatch(
						"parameters/openDialog",
						{
							titleText: "Erro",
							titleColor: "red",
							text: error.message,
						},
						{ root: true },
					)
					return false
				})
			dispatch("parameters/openGlobalLoading", { showLoadingGlobal: false, text: "" }, { root: true })
			return payload
		},
		async update({ commit, dispatch, getters }) {
			dispatch(
				"parameters/openGlobalLoading",
				{ showLoadingGlobal: true, text: "Salvando", indeterminate: true },
				{ root: true },
			)
			let payload = await this._vm.$axios
				.put("/Oryx/BusinessOperation/Update", getters.getCv3)
				.then(response => {
					Utils.ValidateAxiosResponse(response.data)
					commit("initForm")
					return true
				})
				.catch(error => {
					dispatch(
						"parameters/openDialog",
						{
							titleText: "Erro",
							titleColor: "red",
							text: error.message,
						},
						{ root: true },
					)
					return false
				})
			dispatch("parameters/openGlobalLoading", { showLoadingGlobal: false, text: "" }, { root: true })
			return payload
		},
		async delete({ dispatch, getters }) {
			dispatch(
				"parameters/openGlobalLoading",
				{ showLoadingGlobal: true, text: "Excluindo", indeterminate: true },
				{ root: true },
			)
			let payload = await this._vm.$axios
				.delete(`/Oryx/BusinessOperation/Delete/${getters.getCv3opercom}`)
				.then(response => {
					Utils.ValidateAxiosResponse(response.data)
					return true
				})
				.catch(error => {
					dispatch(
						"parameters/openDialog",
						{
							titleText: "Erro",
							titleColor: "red",
							text: error.message,
						},
						{ root: true },
					)
					return false
				})
			dispatch("parameters/openGlobalLoading", { showLoadingGlobal: false, text: "" }, { root: true })
			return payload
		},
		async search({ commit, dispatch, getters }, { limit = 20, page = 1, cv3inativa = false, cv3entsai = 0 }) {
			commit("setLoading", true)
			commit("initForm")
			let payload = await this._vm.$axios
				.get(
					`/Oryx/BusinessOperation/Search?search=${getters.getSearch}&limit=${limit}&page=${page}${
						cv3inativa ? "&cv3inativa=true" : ""
					}${cv3entsai != 0 ? "&cv3entsai=" + cv3entsai : ""}`,
				)
				.then(response => {
					let payload = Utils.ValidateAxiosResponse(response.data)
					commit("setParamsDataTable", payload)
					return true
				})
				.catch(error => {
					commit("setLstCv3", [])
					commit("setSearch", "")
					dispatch(
						"parameters/openDialog",
						{
							titleText: "Erro",
							titleColor: "red",
							text: error.message,
						},
						{ root: true },
					)
					return false
				})
			commit("setLoading", false)
			return payload
		},
		cleanCv3({ getters }) {
			var cv3 = getters.getCv3
			if (getters.getUpdate) {
				Utils.ResetPropertiesValuesByPropertiesNamesBySelfType(cv3, getters.getLstDisabledFields)
				getters.getLstDisabledTabs.forEach(disabledTab => {
					Utils.ResetPropertiesValuesByPropertiesNamesBySelfType(
						cv3,
						getters.getTabsFieldsToDisableAndCleanCaseCv3entsai3Or4[disabledTab],
					)
				})
			}
		},
		async getCv3WithlstCv4({ dispatch }, cv3opercom) {
			return await this._vm.$axios
				.get(`/Oryx/BusinessOperation/Find/${cv3opercom}`)
				.then(response => {
					return Utils.ValidateAxiosResponse(response.data)
				})
				.catch(error => {
					dispatch(
						"parameters/openDialog",
						{
							titleText: "Erro",
							titleColor: "red",
							text: error.message,
						},
						{ root: true },
					)
					return null
				})
		},
	},
}
